module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-M01_r3-clean-176e628885ed9f752f96f6f806695859.png";